/**
 * Semantic Spacing Tokens — CSS variable references.
 */

export const spacing = {
  0: "var(--sp-0)",
  1: "var(--sp-1)",
  2: "var(--sp-2)",
  3: "var(--sp-3)",
  4: "var(--sp-4)",
  6: "var(--sp-6)",
  8: "var(--sp-8)",
  10: "var(--sp-10)",
  12: "var(--sp-12)",
  14: "var(--sp-14)",
  16: "var(--sp-16)",
  20: "var(--sp-20)",
  24: "var(--sp-24)",
  32: "var(--sp-32)",
} as const;
